/** The result line of a form post (qcw-alert-ok / qcw-alert-error). */
export function Alert({ message, ok }: { message: string | null; ok: boolean }) {
  if (!message || message.trim() === '') return null;
  return (
    <div className={`qcw-alert ${ok ? 'qcw-alert-ok' : 'qcw-alert-error'}`} role={ok ? 'status' : 'alert'}>
      {message}
    </div>
  );
}

export interface Outcome {
  message: string | null;
  ok: boolean;
}

export const NO_OUTCOME: Outcome = { message: null, ok: false };
